(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collapsible-text"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('collapsible-text')) return;

    var MOBILE_QUERY = '(max-width: 749px)';
    var CLASS_OVERFLOW = 'collapsible-text--overflowing';
    var CLASS_EXPANDED = 'collapsible-text--expanded';
    var CLASS_IN_MODAL = 'collapsible-text--in-modal';

    class CollapsibleText extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia(MOBILE_QUERY);
        this.frame = null;
        this.handleToggle = this.handleToggle.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        this.handleDialogClick = this.handleDialogClick.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.scheduleMeasure = this.scheduleMeasure.bind(this);
        this.handleEditorSelect = this.handleEditorSelect.bind(this);
        this.handleEditorDeselect = this.handleEditorDeselect.bind(this);
      }

      connectedCallback() {
        this.clampEl = this.clampEl || this.querySelector('[data-collapsible-clamp]');
        this.contentEl = this.contentEl || this.querySelector('[data-collapsible-content]');
        this.toggleEl = this.toggleEl || this.querySelector('[data-collapsible-toggle]');
        this.dialogEl = this.dialogEl || this.querySelector('[data-collapsible-dialog]');
        this.modalBodyEl = this.dialogEl && this.dialogEl.querySelector('[data-collapsible-modal-body]');

        if (!this.clampEl || !this.contentEl || !this.toggleEl) return;

        // Dialog ans <body> hängen, damit ihn kein transform/overflow der
        // Section einsperrt.
        if (this.dialogEl && this.dialogEl.parentElement !== document.body) {
          document.body.appendChild(this.dialogEl);
        }

        this.toggleEl.addEventListener('click', this.handleToggle);

        if (this.dialogEl) {
          this.dialogEl.addEventListener('close', this.handleDialogClose);
          this.dialogEl.addEventListener('click', this.handleDialogClick);
          var closeBtn = this.dialogEl.querySelector('[data-collapsible-close]');
          if (closeBtn) closeBtn.addEventListener('click', this.handleClose);
        }

        if (this.mql.addEventListener) {
          this.mql.addEventListener('change', this.handleMediaChange);
        } else {
          this.mql.addListener(this.handleMediaChange);
        }

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.scheduleMeasure);
          this.observer.observe(this.contentEl);
        }
        window.addEventListener('resize', this.scheduleMeasure);
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(this.scheduleMeasure);
        }

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.handleEditorSelect);
          document.addEventListener('shopify:block:deselect', this.handleEditorDeselect);
        }

        this.measure();
      }

      disconnectedCallback() {
        if (this.toggleEl) this.toggleEl.removeEventListener('click', this.handleToggle);

        if (this.dialogEl) {
          this.restoreContent();
          if (this.dialogEl.open) this.dialogEl.close();
          this.dialogEl.removeEventListener('close', this.handleDialogClose);
          this.dialogEl.removeEventListener('click', this.handleDialogClick);
          var closeBtn = this.dialogEl.querySelector('[data-collapsible-close]');
          if (closeBtn) closeBtn.removeEventListener('click', this.handleClose);
          this.dialogEl.remove();
        }

        if (this.mql.removeEventListener) {
          this.mql.removeEventListener('change', this.handleMediaChange);
        } else {
          this.mql.removeListener(this.handleMediaChange);
        }

        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.scheduleMeasure);
        document.removeEventListener('shopify:block:select', this.handleEditorSelect);
        document.removeEventListener('shopify:block:deselect', this.handleEditorDeselect);
        this.unlockScroll();
      }

      get isModal() {
        return this.dataset.mode === 'modal';
      }

      /* --- Messen --------------------------------------------------------- */

      scheduleMeasure() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(function () {
          this.frame = null;
          this.measure();
        }.bind(this));
      }

      measure() {
        if (!this.contentEl) return;

        if (!this.mql.matches) {
          this.classList.remove(CLASS_OVERFLOW);
          return;
        }

        // Solange der Inhalt im Modal liegt, ist die Messung nicht aussagekräftig.
        if (this.classList.contains(CLASS_IN_MODAL)) return;

        var lineHeight = this.lineHeight();
        this.setVar('--collapsible-text-line-height', lineHeight + 'px');

        var lines = parseFloat(getComputedStyle(this).getPropertyValue('--collapsible-text-lines')) || 3;
        var collapsedHeight = lineHeight * lines;
        var fullHeight = this.contentEl.getBoundingClientRect().height;

        this.setVar('--collapsible-text-expanded-height', Math.ceil(fullHeight) + 'px');

        var overflowing = fullHeight - collapsedHeight > 1;
        this.classList.toggle(CLASS_OVERFLOW, overflowing);
        if (!overflowing) this.collapse();
      }

      lineHeight() {
        var probe =
          this.contentEl.querySelector('p, li, h1, h2, h3, h4, h5, h6, span, div') || this.contentEl;
        var styles = getComputedStyle(probe);
        var value = parseFloat(styles.lineHeight);
        if (!isFinite(value) || value <= 0) value = parseFloat(styles.fontSize) * 1.5;
        return value;
      }

      setVar(name, value) {
        if (this.style.getPropertyValue(name) === value) return;
        this.style.setProperty(name, value);
      }

      /* --- Inline --------------------------------------------------------- */

      handleToggle() {
        if (this.isModal) {
          this.openModal();
        } else if (this.classList.contains(CLASS_EXPANDED)) {
          this.collapse();
        } else {
          this.expand();
        }
      }

      expand() {
        this.measureExpandedHeight();
        this.classList.add(CLASS_EXPANDED);
        this.toggleEl.setAttribute('aria-expanded', 'true');
        var label = this.toggleEl.dataset.labelCollapse;
        if (label) this.toggleEl.setAttribute('aria-label', label);
      }

      collapse() {
        if (!this.classList.contains(CLASS_EXPANDED)) return;
        this.classList.remove(CLASS_EXPANDED);
        this.toggleEl.setAttribute('aria-expanded', 'false');
        var label = this.toggleEl.dataset.labelExpand;
        if (label) this.toggleEl.setAttribute('aria-label', label);
      }

      measureExpandedHeight() {
        var fullHeight = this.contentEl.getBoundingClientRect().height;
        this.setVar('--collapsible-text-expanded-height', Math.ceil(fullHeight) + 'px');
      }

      /* --- Modal ---------------------------------------------------------- */

      // Der Dialog hängt am <body> und erbt darum die Farbschema-Variablen
      // der Section nicht. Deshalb die tatsächlich gerenderten Farben
      // übernehmen, statt auf einen bestimmten Variablennamen zu setzen.
      applyModalColors() {
        var styles = getComputedStyle(this);
        this.dialogEl.style.setProperty('--collapsible-text-modal-fg', styles.color);

        var node = this;
        var background = '';
        while (node && node.nodeType === 1) {
          var value = getComputedStyle(node).backgroundColor;
          if (value && value !== 'transparent' && !/^rgba\(0, 0, 0, 0\)$/.test(value)) {
            background = value;
            break;
          }
          node = node.parentElement;
        }
        this.dialogEl.style.setProperty('--collapsible-text-modal-bg', background || '#fff');
        this.dialogEl.style.font = styles.font || '';
      }

      openModal() {
        if (!this.dialogEl || !this.modalBodyEl || this.dialogEl.open) return;
        this.applyModalColors();
        this.modalBodyEl.appendChild(this.contentEl);
        this.classList.add(CLASS_IN_MODAL);
        this.lockScroll();
        this.dialogEl.showModal();
      }

      handleClose() {
        if (this.dialogEl && this.dialogEl.open) this.dialogEl.close();
      }

      handleDialogClick(event) {
        if (event.target === this.dialogEl) this.handleClose();
      }

      handleDialogClose() {
        this.restoreContent();
        this.unlockScroll();
        this.measure();
        if (this.toggleEl && this.isConnected) this.toggleEl.focus();
      }

      restoreContent() {
        if (!this.clampEl || !this.contentEl) return;
        if (this.contentEl.parentElement !== this.clampEl) {
          this.clampEl.appendChild(this.contentEl);
        }
        this.classList.remove(CLASS_IN_MODAL);
      }

      lockScroll() {
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
      }

      unlockScroll() {
        if (this.previousOverflow === undefined) return;
        document.documentElement.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }

      /* --- Sonstiges ------------------------------------------------------ */

      handleMediaChange() {
        if (!this.mql.matches) {
          this.handleClose();
          this.collapse();
        }
        this.scheduleMeasure();
      }

      // Im Theme-Editor: Auswahl eines Kind-Blocks zeigt den Inhalt an.
      handleEditorSelect(event) {
        if (!this.contains(event.target) || event.target === this) return;
        if (!this.mql.matches) return;
        if (this.isModal) {
          this.openModal();
        } else {
          this.expand();
        }
      }

      handleEditorDeselect(event) {
        if (!this.contains(event.target) || event.target === this) return;
        if (this.isModal) this.handleClose();
      }
    }

    customElements.define('collapsible-text', CollapsibleText);
  })();
  } catch(e) { console.error(e); }
})();

})();
